export function calculateValue(value, months, discount) {
  return value - ((value*discount)/ 100)
}